import React from "react";

const Java_round = () => {
  return (
    <div>
      <h1>Java round</h1>
      <p>This page provides explanations, examples, and common use-cases for Java round in Java.</p>
    </div>
  );
};

export default Java_round;
